'use client'; // Error boundaries must be Client Components

import ErrorContent from '@alltrails/layout/components/ErrorContent';

export default function Error() {
  return <ErrorContent />;
}
